export const ProfilePageTestIds = {
  bulkPromotion: {
    entryButton: 'bulk-promotion-entry-button',
    successModal: 'bulk-promotion-success-modal',
  },
};
